export default __webpack_public_path__ + "static/media/logo.e4d9257b.png";